import React from 'react';
import { Stack } from '@mantine/core';
import IconPickerField from '../../../puck/fields/IconPickerField';
import { PuckColorFieldWithPalette } from '../../../puck/fields/createPuckColorField';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import { useThemeLockedProp } from '../../../puck/fields/themedFieldValues';

/** Blanc : couleur du libellé sur un bouton plein, donc celle de l'icône. */
const DEFAULT_ICON_COLOR = '#ffffff';

/**
 * Champ « Icône » du bouton : le picker Tabler partagé, et la couleur de
 * l'icône seulement quand il y en a une — un sélecteur de couleur sans icône
 * n'a rien à colorer.
 *
 * Ancré sur `icon` ; `iconColor` est un prop frère, écrit par dispatch (le
 * onChange d'un champ Puck ne couvre que sa propre prop).
 */
export default function ButtonIconField({ value, onChange }) {
  const { itemProps, updateItemProps } = useSelectedItemProps();
  const isLocked = useThemeLockedProp('button');

  return (
    <Stack gap="sm">
      <IconPickerField value={value} onChange={onChange} />
      {value && !isLocked('iconColor') && (
        <PuckColorFieldWithPalette
          label="Couleur de l'icône"
          value={itemProps.iconColor || DEFAULT_ICON_COLOR}
          onChange={(iconColor) => updateItemProps({ iconColor: iconColor ?? '' })}
        />
      )}
    </Stack>
  );
}
